import { useState, useEffect } from "react";

export default function CookieManager() {
  const [showManager, setShowManager] = useState(false);

  useEffect(() => {
    const openManager = () => setShowManager(true);
    window.addEventListener("openCookieManager", openManager);

    return () => window.removeEventListener("openCookieManager", openManager);
  }, []);

  if (!showManager) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white text-black p-6 rounded-xl max-w-lg">
        <h2 className="text-xl font-bold mb-4">Gerenciar Cookies</h2>

        <p className="mb-4">
          Você pode escolher quais cookies deseja permitir no site.
        </p>

        <div className="flex flex-col gap-3">

          <label>
            <input type="checkbox" checked disabled /> 
            Cookies essenciais
          </label>

          <label>
            <input type="checkbox" /> 
            Cookies de analytics
          </label>

          <label>
            <input type="checkbox" /> 
            Cookies de marketing
          </label>

        </div>

        <div className="flex gap-3 mt-6">
          <button
            className="bg-black text-white px-4 py-2 rounded"
            onClick={() => setShowManager(false)}
          >
            Salvar
          </button>

          <button
            className="border px-4 py-2 rounded"
            onClick={() => setShowManager(false)}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}